// @flow
import React, {PureComponent} from "react";
import {SelectionButton} from "../../../AppStyle";
import {isTouchingElement} from "../../../../Utils/AppUtils";


type OwnProps = {
    parentActive: boolean,
    terminal: any,
    onTerminalSelect: any,
}
type State = {
    active: boolean,
    hovering: boolean
}

class TerminalSelectionButton extends PureComponent<OwnProps, State> {

    onTouchStart: () => void;
    onTouchEnd: () => void;
    onMouseEnter: () => void;
    onMouseLeave: () => void;

    constructor() {
        super();

        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.state = {
            active: false,
            hovering: false,
        };
    }

    onTouchStart() {
        this.setState({active: true, hovering: true});
    }

    onTouchEnd() {
        if (this.state.active && this.state.hovering) {
            this.props.onTerminalSelect(this.props.terminal);
        }
        this.setState({active: false});
    }

    onMouseEnter() {
        this.setState({hovering: this.props.parentActive});
    }

    onMouseLeave() {
        this.setState({hovering: false});
    }


    render() {
        return (
            <SelectionButton active={this.state.active && this.state.hovering}
                             onTouchStart={this.onTouchStart}
                             onMouseDown={this.onTouchStart}
                             onTouchEnd={this.onTouchEnd}
                             onMouseUp={this.onTouchEnd}
                             onMouseEnter={this.onMouseEnter}
                             onMouseLeave={this.onMouseLeave}
                             onTouchMove={(e) => {
                                 const target = e.currentTarget;
                                 const nativeEvent = e.nativeEvent;
                                 const changedTouches: TouchList = nativeEvent.changedTouches;
                                 const x = changedTouches[0].clientX;
                                 const y = changedTouches[0].clientY;
                                 this.setState({hovering: isTouchingElement(target, x, y)});
                             }}
            >
                {this.props.terminal.label}
            </SelectionButton>
        );
    }
}

export default TerminalSelectionButton;


// WEBPACK FOOTER //
// ./src/Components/Screen/RideRequest/TerminalSelection/TerminalSelectionButton.js